/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCategoryModel = /* GraphQL */ `
  mutation CreateCategoryModel(
    $input: CreateCategoryModelInput!
    $condition: ModelCategoryModelConditionInput
  ) {
    createCategoryModel(input: $input, condition: $condition) {
      id
      nameTA
      nameEN
      isFeatured
      children {
        nextToken
        __typename
      }
      primaryVideos {
        nextToken
        __typename
      }
      secondaryVideos {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      categoryModelChildrenId
      __typename
    }
  }
`;
export const updateCategoryModel = /* GraphQL */ `
  mutation UpdateCategoryModel(
    $input: UpdateCategoryModelInput!
    $condition: ModelCategoryModelConditionInput
  ) {
    updateCategoryModel(input: $input, condition: $condition) {
      id
      nameTA
      nameEN
      isFeatured
      children {
        nextToken
        __typename
      }
      primaryVideos {
        nextToken
        __typename
      }
      secondaryVideos {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      categoryModelChildrenId
      __typename
    }
  }
`;
export const deleteCategoryModel = /* GraphQL */ `
  mutation DeleteCategoryModel(
    $input: DeleteCategoryModelInput!
    $condition: ModelCategoryModelConditionInput
  ) {
    deleteCategoryModel(input: $input, condition: $condition) {
      id
      nameTA
      nameEN
      isFeatured
      children {
        nextToken
        __typename
      }
      primaryVideos {
        nextToken
        __typename
      }
      secondaryVideos {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      categoryModelChildrenId
      __typename
    }
  }
`;
export const createVideoModel = /* GraphQL */ `
  mutation CreateVideoModel(
    $input: CreateVideoModelInput!
    $condition: ModelVideoModelConditionInput
  ) {
    createVideoModel(input: $input, condition: $condition) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      status
      titleEN
      titleTA
      descriptionTA
      duration
      likesCount
      dislikesCount
      commentsCount
      primaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      secondaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
      viewsCount
      publishState
      significantDate
      isFeatured
      descriptionEN
      errorMessage
      size
      imageName
      thumbnailUrl
      videoUrl
      externalVideoUrl
      notifications {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      tags {
        nextToken
        __typename
      }
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateVideoModel = /* GraphQL */ `
  mutation UpdateVideoModel(
    $input: UpdateVideoModelInput!
    $condition: ModelVideoModelConditionInput
  ) {
    updateVideoModel(input: $input, condition: $condition) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      status
      titleEN
      titleTA
      descriptionTA
      duration
      likesCount
      dislikesCount
      commentsCount
      primaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      secondaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
      viewsCount
      publishState
      significantDate
      isFeatured
      descriptionEN
      errorMessage
      size
      imageName
      thumbnailUrl
      videoUrl
      externalVideoUrl
      notifications {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      tags {
        nextToken
        __typename
      }
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteVideoModel = /* GraphQL */ `
  mutation DeleteVideoModel(
    $input: DeleteVideoModelInput!
    $condition: ModelVideoModelConditionInput
  ) {
    deleteVideoModel(input: $input, condition: $condition) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      status
      titleEN
      titleTA
      descriptionTA
      duration
      likesCount
      dislikesCount
      commentsCount
      primaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      secondaryCategory {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      videoModelPrimaryCategoryId
      videoModelSecondaryCategoryId
      viewsCount
      publishState
      significantDate
      isFeatured
      descriptionEN
      errorMessage
      size
      imageName
      thumbnailUrl
      videoUrl
      externalVideoUrl
      notifications {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      tags {
        nextToken
        __typename
      }
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createUserModel = /* GraphQL */ `
  mutation CreateUserModel(
    $input: CreateUserModelInput!
    $condition: ModelUserModelConditionInput
  ) {
    createUserModel(input: $input, condition: $condition) {
      id
      username
      createdAt
      email
      lastName
      passwordHash
      ipAddress
      emailVerified
      status
      firstName
      displayName
      gender
      birthday
      fbId
      twitterId
      instagramId
      linkedInId
      clubHouseId
      interestedCategories {
        nextToken
        __typename
      }
      phone
      paypalEmail
      viewsCount
      videos {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      country
      bio
      isPro
      lastActiveAt
      subscribersCount
      likedVideosCount
      subscribers {
        nextToken
        __typename
      }
      subscribedTo {
        nextToken
        __typename
      }
      blockers {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      commentInteractions {
        nextToken
        __typename
      }
      legacyAvatar
      legacyCover
      legacyId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateUserModel = /* GraphQL */ `
  mutation UpdateUserModel(
    $input: UpdateUserModelInput!
    $condition: ModelUserModelConditionInput
  ) {
    updateUserModel(input: $input, condition: $condition) {
      id
      username
      createdAt
      email
      lastName
      passwordHash
      ipAddress
      emailVerified
      status
      firstName
      displayName
      gender
      birthday
      fbId
      twitterId
      instagramId
      linkedInId
      clubHouseId
      interestedCategories {
        nextToken
        __typename
      }
      phone
      paypalEmail
      viewsCount
      videos {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      country
      bio
      isPro
      lastActiveAt
      subscribersCount
      likedVideosCount
      subscribers {
        nextToken
        __typename
      }
      subscribedTo {
        nextToken
        __typename
      }
      blockers {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      commentInteractions {
        nextToken
        __typename
      }
      legacyAvatar
      legacyCover
      legacyId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteUserModel = /* GraphQL */ `
  mutation DeleteUserModel(
    $input: DeleteUserModelInput!
    $condition: ModelUserModelConditionInput
  ) {
    deleteUserModel(input: $input, condition: $condition) {
      id
      username
      createdAt
      email
      lastName
      passwordHash
      ipAddress
      emailVerified
      status
      firstName
      displayName
      gender
      birthday
      fbId
      twitterId
      instagramId
      linkedInId
      clubHouseId
      interestedCategories {
        nextToken
        __typename
      }
      phone
      paypalEmail
      viewsCount
      videos {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      sentMessages {
        nextToken
        __typename
      }
      receivedMessages {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      country
      bio
      isPro
      lastActiveAt
      subscribersCount
      likedVideosCount
      subscribers {
        nextToken
        __typename
      }
      subscribedTo {
        nextToken
        __typename
      }
      blockers {
        nextToken
        __typename
      }
      blockedUsers {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      commentInteractions {
        nextToken
        __typename
      }
      legacyAvatar
      legacyCover
      legacyId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createUserSubscriber = /* GraphQL */ `
  mutation CreateUserSubscriber(
    $input: CreateUserSubscriberInput!
    $condition: ModelUserSubscriberConditionInput
  ) {
    createUserSubscriber(input: $input, condition: $condition) {
      id
      subscriber {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscriberId
      subscribedTo {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscribedToId
      notify
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateUserSubscriber = /* GraphQL */ `
  mutation UpdateUserSubscriber(
    $input: UpdateUserSubscriberInput!
    $condition: ModelUserSubscriberConditionInput
  ) {
    updateUserSubscriber(input: $input, condition: $condition) {
      id
      subscriber {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscriberId
      subscribedTo {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscribedToId
      notify
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteUserSubscriber = /* GraphQL */ `
  mutation DeleteUserSubscriber(
    $input: DeleteUserSubscriberInput!
    $condition: ModelUserSubscriberConditionInput
  ) {
    deleteUserSubscriber(input: $input, condition: $condition) {
      id
      subscriber {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscriberId
      subscribedTo {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      subscribedToId
      notify
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createUserBlocked = /* GraphQL */ `
  mutation CreateUserBlocked(
    $input: CreateUserBlockedInput!
    $condition: ModelUserBlockedConditionInput
  ) {
    createUserBlocked(input: $input, condition: $condition) {
      id
      blocker {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockerId
      blockedUser {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockedUserId
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateUserBlocked = /* GraphQL */ `
  mutation UpdateUserBlocked(
    $input: UpdateUserBlockedInput!
    $condition: ModelUserBlockedConditionInput
  ) {
    updateUserBlocked(input: $input, condition: $condition) {
      id
      blocker {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockerId
      blockedUser {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockedUserId
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteUserBlocked = /* GraphQL */ `
  mutation DeleteUserBlocked(
    $input: DeleteUserBlockedInput!
    $condition: ModelUserBlockedConditionInput
  ) {
    deleteUserBlocked(input: $input, condition: $condition) {
      id
      blocker {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockerId
      blockedUser {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      blockedUserId
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createCommentModel = /* GraphQL */ `
  mutation CreateCommentModel(
    $input: CreateCommentModelInput!
    $condition: ModelCommentModelConditionInput
  ) {
    createCommentModel(input: $input, condition: $condition) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      replyTo {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      replyToId
      message
      likesCount
      dislikesCount
      replies {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      updatedAt
      commentModelRepliesId
      authOwner
      __typename
    }
  }
`;
export const updateCommentModel = /* GraphQL */ `
  mutation UpdateCommentModel(
    $input: UpdateCommentModelInput!
    $condition: ModelCommentModelConditionInput
  ) {
    updateCommentModel(input: $input, condition: $condition) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      replyTo {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      replyToId
      message
      likesCount
      dislikesCount
      replies {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      updatedAt
      commentModelRepliesId
      authOwner
      __typename
    }
  }
`;
export const deleteCommentModel = /* GraphQL */ `
  mutation DeleteCommentModel(
    $input: DeleteCommentModelInput!
    $condition: ModelCommentModelConditionInput
  ) {
    deleteCommentModel(input: $input, condition: $condition) {
      id
      createdAt
      owner {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      ownerId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      replyTo {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      replyToId
      message
      likesCount
      dislikesCount
      replies {
        nextToken
        __typename
      }
      notifications {
        nextToken
        __typename
      }
      interactions {
        nextToken
        __typename
      }
      updatedAt
      commentModelRepliesId
      authOwner
      __typename
    }
  }
`;
export const createNotificationModel = /* GraphQL */ `
  mutation CreateNotificationModel(
    $input: CreateNotificationModelInput!
    $condition: ModelNotificationModelConditionInput
  ) {
    createNotificationModel(input: $input, condition: $condition) {
      id
      createdAt
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      type
      profile {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      profileId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      message {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      messageId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      updatedAt
      videoModelNotificationsId
      commentModelNotificationsId
      __typename
    }
  }
`;
export const updateNotificationModel = /* GraphQL */ `
  mutation UpdateNotificationModel(
    $input: UpdateNotificationModelInput!
    $condition: ModelNotificationModelConditionInput
  ) {
    updateNotificationModel(input: $input, condition: $condition) {
      id
      createdAt
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      type
      profile {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      profileId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      message {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      messageId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      updatedAt
      videoModelNotificationsId
      commentModelNotificationsId
      __typename
    }
  }
`;
export const deleteNotificationModel = /* GraphQL */ `
  mutation DeleteNotificationModel(
    $input: DeleteNotificationModelInput!
    $condition: ModelNotificationModelConditionInput
  ) {
    deleteNotificationModel(input: $input, condition: $condition) {
      id
      createdAt
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      type
      profile {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      profileId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      message {
        id
        content
        senderId
        receiverId
        conversationId
        senderAuthOwner
        receiverAuthOwner
        createdAt
        updatedAt
        isRead
        lastMessageAt
        messageModelNotificationId
        __typename
      }
      messageId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      updatedAt
      videoModelNotificationsId
      commentModelNotificationsId
      __typename
    }
  }
`;
export const createMessageModel = /* GraphQL */ `
  mutation CreateMessageModel(
    $input: CreateMessageModelInput!
    $condition: ModelMessageModelConditionInput
  ) {
    createMessageModel(input: $input, condition: $condition) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      sender {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      receiver {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      isRead
      lastMessageAt
      notification {
        id
        createdAt
        userId
        type
        profileId
        commentId
        messageId
        videoId
        updatedAt
        videoModelNotificationsId
        commentModelNotificationsId
        __typename
      }
      messageModelNotificationId
      __typename
    }
  }
`;
export const updateMessageModel = /* GraphQL */ `
  mutation UpdateMessageModel(
    $input: UpdateMessageModelInput!
    $condition: ModelMessageModelConditionInput
  ) {
    updateMessageModel(input: $input, condition: $condition) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      sender {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      receiver {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      isRead
      lastMessageAt
      notification {
        id
        createdAt
        userId
        type
        profileId
        commentId
        messageId
        videoId
        updatedAt
        videoModelNotificationsId
        commentModelNotificationsId
        __typename
      }
      messageModelNotificationId
      __typename
    }
  }
`;
export const deleteMessageModel = /* GraphQL */ `
  mutation DeleteMessageModel(
    $input: DeleteMessageModelInput!
    $condition: ModelMessageModelConditionInput
  ) {
    deleteMessageModel(input: $input, condition: $condition) {
      id
      content
      senderId
      receiverId
      conversationId
      senderAuthOwner
      receiverAuthOwner
      sender {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      receiver {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      isRead
      lastMessageAt
      notification {
        id
        createdAt
        userId
        type
        profileId
        commentId
        messageId
        videoId
        updatedAt
        videoModelNotificationsId
        commentModelNotificationsId
        __typename
      }
      messageModelNotificationId
      __typename
    }
  }
`;
export const createVideoInteractionModel = /* GraphQL */ `
  mutation CreateVideoInteractionModel(
    $input: CreateVideoInteractionModelInput!
    $condition: ModelVideoInteractionModelConditionInput
  ) {
    createVideoInteractionModel(input: $input, condition: $condition) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      watchPercentage
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateVideoInteractionModel = /* GraphQL */ `
  mutation UpdateVideoInteractionModel(
    $input: UpdateVideoInteractionModelInput!
    $condition: ModelVideoInteractionModelConditionInput
  ) {
    updateVideoInteractionModel(input: $input, condition: $condition) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      watchPercentage
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteVideoInteractionModel = /* GraphQL */ `
  mutation DeleteVideoInteractionModel(
    $input: DeleteVideoInteractionModelInput!
    $condition: ModelVideoInteractionModelConditionInput
  ) {
    deleteVideoInteractionModel(input: $input, condition: $condition) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      video {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      videoId
      watchPercentage
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createCommentInteractionModel = /* GraphQL */ `
  mutation CreateCommentInteractionModel(
    $input: CreateCommentInteractionModelInput!
    $condition: ModelCommentInteractionModelConditionInput
  ) {
    createCommentInteractionModel(input: $input, condition: $condition) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      videoId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateCommentInteractionModel = /* GraphQL */ `
  mutation UpdateCommentInteractionModel(
    $input: UpdateCommentInteractionModelInput!
    $condition: ModelCommentInteractionModelConditionInput
  ) {
    updateCommentInteractionModel(input: $input, condition: $condition) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      videoId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteCommentInteractionModel = /* GraphQL */ `
  mutation DeleteCommentInteractionModel(
    $input: DeleteCommentInteractionModelInput!
    $condition: ModelCommentInteractionModelConditionInput
  ) {
    deleteCommentInteractionModel(input: $input, condition: $condition) {
      id
      createdAt
      type
      user {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      userId
      comment {
        id
        createdAt
        ownerId
        videoId
        replyToId
        message
        likesCount
        dislikesCount
        updatedAt
        commentModelRepliesId
        authOwner
        __typename
      }
      commentId
      videoId
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createTagModel = /* GraphQL */ `
  mutation CreateTagModel(
    $input: CreateTagModelInput!
    $condition: ModelTagModelConditionInput
  ) {
    createTagModel(input: $input, condition: $condition) {
      id
      label
      videos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTagModel = /* GraphQL */ `
  mutation UpdateTagModel(
    $input: UpdateTagModelInput!
    $condition: ModelTagModelConditionInput
  ) {
    updateTagModel(input: $input, condition: $condition) {
      id
      label
      videos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTagModel = /* GraphQL */ `
  mutation DeleteTagModel(
    $input: DeleteTagModelInput!
    $condition: ModelTagModelConditionInput
  ) {
    deleteTagModel(input: $input, condition: $condition) {
      id
      label
      videos {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserCategories = /* GraphQL */ `
  mutation CreateUserCategories(
    $input: CreateUserCategoriesInput!
    $condition: ModelUserCategoriesConditionInput
  ) {
    createUserCategories(input: $input, condition: $condition) {
      id
      categoryModelID
      userModelID
      categoryModel {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      userModel {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateUserCategories = /* GraphQL */ `
  mutation UpdateUserCategories(
    $input: UpdateUserCategoriesInput!
    $condition: ModelUserCategoriesConditionInput
  ) {
    updateUserCategories(input: $input, condition: $condition) {
      id
      categoryModelID
      userModelID
      categoryModel {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      userModel {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteUserCategories = /* GraphQL */ `
  mutation DeleteUserCategories(
    $input: DeleteUserCategoriesInput!
    $condition: ModelUserCategoriesConditionInput
  ) {
    deleteUserCategories(input: $input, condition: $condition) {
      id
      categoryModelID
      userModelID
      categoryModel {
        id
        nameTA
        nameEN
        isFeatured
        createdAt
        updatedAt
        categoryModelChildrenId
        __typename
      }
      userModel {
        id
        username
        createdAt
        email
        lastName
        passwordHash
        ipAddress
        emailVerified
        status
        firstName
        displayName
        gender
        birthday
        fbId
        twitterId
        instagramId
        linkedInId
        clubHouseId
        phone
        paypalEmail
        viewsCount
        country
        bio
        isPro
        lastActiveAt
        subscribersCount
        likedVideosCount
        legacyAvatar
        legacyCover
        legacyId
        updatedAt
        authOwner
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const createVideoTags = /* GraphQL */ `
  mutation CreateVideoTags(
    $input: CreateVideoTagsInput!
    $condition: ModelVideoTagsConditionInput
  ) {
    createVideoTags(input: $input, condition: $condition) {
      id
      videoModelID
      tagModelID
      videoModel {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      tagModel {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const updateVideoTags = /* GraphQL */ `
  mutation UpdateVideoTags(
    $input: UpdateVideoTagsInput!
    $condition: ModelVideoTagsConditionInput
  ) {
    updateVideoTags(input: $input, condition: $condition) {
      id
      videoModelID
      tagModelID
      videoModel {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      tagModel {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const deleteVideoTags = /* GraphQL */ `
  mutation DeleteVideoTags(
    $input: DeleteVideoTagsInput!
    $condition: ModelVideoTagsConditionInput
  ) {
    deleteVideoTags(input: $input, condition: $condition) {
      id
      videoModelID
      tagModelID
      videoModel {
        id
        createdAt
        ownerId
        status
        titleEN
        titleTA
        descriptionTA
        duration
        likesCount
        dislikesCount
        commentsCount
        videoModelPrimaryCategoryId
        videoModelSecondaryCategoryId
        viewsCount
        publishState
        significantDate
        isFeatured
        descriptionEN
        errorMessage
        size
        imageName
        thumbnailUrl
        videoUrl
        externalVideoUrl
        updatedAt
        authOwner
        __typename
      }
      tagModel {
        id
        label
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      authOwner
      __typename
    }
  }
`;
export const adminConsoleMutation = /* GraphQL */ `
  mutation AdminConsoleMutation($action: String!, $input: AWSJSON) {
    adminConsoleMutation(action: $action, input: $input)
  }
`;
export const backfillAuthOwner = /* GraphQL */ `
  mutation BackfillAuthOwner {
    backfillAuthOwner {
      success
      updatedCount
      message
      __typename
    }
  }
`;
